import { Dialog, DialogProps } from "@progress/kendo-react-dialogs";
import * as styles from "./DialogBox.css.ts";

interface DialogBoxProps extends DialogProps {
  isOpen: boolean;
  children: React.ReactNode;
}

const DialogBox = ({ isOpen = false, children, ...props }: DialogBoxProps) => {
  return (
    <>
      {isOpen && (
        <Dialog {...props}>
          <div className={styles.dialogContainer}>{children}</div>
        </Dialog>
      )}
    </>
  );
};

export default DialogBox;
